import React, { createContext, useContext, useEffect, useState } from "react";
import io from "socket.io-client";

const SocketContext = createContext();

export const useSocket = () => {
    return useContext(SocketContext);
};

export const SocketProvider = ({ children }) => {
    const [socket, setSocket] = useState(null);

    useEffect(() => {
        // Create the socket connection
        const socketInstance = io(`${process.env.REACT_APP_UE_SOCKET_PORT}`);

        // Listen for the "connect" event to log a success message
        socketInstance.on("connect", () => {
            // console.log("Connection successful!");
        });

        // Store the socket instance
        setSocket(socketInstance);

        // Clean up the connection on component unmount
        return () => {
            socketInstance.disconnect();
        };
    }, []);

    return (
        <SocketContext.Provider value={socket}>
            {children}
        </SocketContext.Provider>
    );
};
